var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "user-center-slot",
    [
      _c(
        "user-center-container-slot",
        [
          _c("user-center-menu"),
          _vm._v(" "),
          _c("user-center-content-slot", [
            _c("div", { staticClass: "vul-detail" }, [
              _c(
                "div",
                { staticClass: "vul-detail-breadcrumb" },
                [
                  _c(
                    "xui-breadcrumb",
                    { attrs: { "separator-class": "fa fa-angle-right" } },
                    [
                      _c(
                        "xui-breadcrumb-item",
                        { attrs: { to: { path: "/usercenter/report" } } },
                        [_vm._v("漏洞列表")]
                      ),
                      _vm._v(" "),
                      _c("xui-breadcrumb-item", [_vm._v("漏洞详情页")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__detail-row" }, [
                _c("div", [
                  _c("i", {
                    staticClass:
                      "iconfont icon-_biaodan user-center__detail-icon--default"
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user-center__detail-tips" }, [
                  _vm._v("这是"),
                  _c("span", [_vm._v(" " + _vm._s(_vm.data.vulTitle))]),
                  _vm._v("的详情")
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "vul-step" },
                  [
                    _c(
                      "xui-steps",
                      {
                        attrs: {
                          active: _vm.active,
                          "finish-status": "success",
                          "align-center": ""
                        }
                      },
                      _vm._l(_vm.title, function(item) {
                        return _c("xui-step", {
                          key: item.flowStatus,
                          attrs: { title: item.flowStatusName }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vul-detail-items" },
                  [
                    _c(
                      "xui-row",
                      { staticClass: "item-line" },
                      [
                        _c("xui-col", { attrs: { span: 3 } }, [
                          _c("span", { staticClass: "item-title" }, [
                            _vm._v(" 漏洞名称：")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("xui-col", { attrs: { span: 3 } }, [
                          _c("span", { staticClass: "item-value" }, [
                            _vm._v(" " + _vm._s(_vm.data.vulTitle))
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "xui-row",
                      { staticClass: "item-line" },
                      [
                        _c(
                          "xui-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "xui-row",
                              [
                                _c("xui-col", { attrs: { span: 6 } }, [
                                  _c("span", { staticClass: "item-title" }, [
                                    _vm._v(" 提交时间：")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("xui-col", { attrs: { span: 18 } }, [
                                  _c("span", { staticClass: "item-value" }, [
                                    _vm._v(_vm._s(_vm.data.creationDate))
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "xui-row",
                              [
                                _c("xui-col", { attrs: { span: 6 } }, [
                                  _c("span", { staticClass: "item-title" }, [
                                    _vm._v(" 漏洞编码：")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("xui-col", { attrs: { span: 18 } }, [
                                  _c("span", { staticClass: "item-value" }, [
                                    _vm._v(_vm._s(_vm.data.vulId))
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "xui-row",
                      { staticClass: "item-line" },
                      [
                        _c(
                          "xui-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "xui-row",
                              [
                                _c("xui-col", { attrs: { span: 6 } }, [
                                  _c("span", { staticClass: "item-title" }, [
                                    _vm._v(" 漏洞状态：")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("xui-col", { attrs: { span: 18 } }, [
                                  _c("span", { staticClass: "item-value" }, [
                                    _vm._v(_vm._s(_vm.data.displayStatusName))
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "xui-row",
                              [
                                _c("xui-col", { attrs: { span: 6 } }, [
                                  _c("span", { staticClass: "item-title" }, [
                                    _vm._v(" 漏洞类型：")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("xui-col", { attrs: { span: 18 } }, [
                                  _c("span", { staticClass: "item-value" }, [
                                    _vm._v(_vm._s(_vm.data.vulTypeName))
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "xui-row",
                      { staticClass: "item-line" },
                      [
                        _c(
                          "xui-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "xui-row",
                              [
                                _c("xui-col", { attrs: { span: 6 } }, [
                                  _c("span", { staticClass: "item-title" }, [
                                    _vm._v(" 漏洞等级：")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("xui-col", { attrs: { span: 18 } }, [
                                  _c("span", { staticClass: "item-value" }, [
                                    _vm._v(_vm._s(_vm.data.vulLevelName))
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "xui-row",
                              [
                                _c("xui-col", { attrs: { span: 6 } }, [
                                  _c("span", { staticClass: "item-title" }, [
                                    _vm._v(" 漏洞奖金：")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("xui-col", { attrs: { span: 18 } }, [
                                  _c("span", { staticClass: "item-value" }, [
                                    _vm._v(_vm._s(_vm.data.amount))
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "xui-row",
                      { staticClass: "item-line" },
                      [
                        _c(
                          "xui-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "xui-row",
                              [
                                _c("xui-col", { attrs: { span: 6 } }, [
                                  _c("span", { staticClass: "item-title" }, [
                                    _vm._v(" 修复版本：")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("xui-col", { attrs: { span: 18 } }, [
                                  _c("span", { staticClass: "item-value" }, [
                                    _vm._v(
                                      _vm._s(_vm.data.feedbackFixedVersion)
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "xui-row",
                      { staticClass: "item-line" },
                      [
                        _c(
                          "xui-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "xui-row",
                              [
                                _c("xui-col", { attrs: { span: 6 } }, [
                                  _c("span", { staticClass: "item-title" }, [
                                    _vm._v(" 漏洞附件：")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "xui-col",
                                  { attrs: { span: 18 } },
                                  _vm._l(_vm.data.attachmentList, function(
                                    ele,
                                    i
                                  ) {
                                    return _c(
                                      "span",
                                      {
                                        key: i,
                                        staticClass: "attachment_uploadFile"
                                      },
                                      [
                                        _c("span", [
                                          _c("i", { staticClass: "fa fa-file" })
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "xui-link",
                                          {
                                            key: _vm.index,
                                            staticClass:
                                              "attachment_uploadFile_xui-link",
                                            attrs: {
                                              href: _vm.jumpUrl(ele),
                                              disabled: ele.disabled,
                                              type: "primary",
                                              target: "_blank",
                                              title: ele.docName
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                 " +
                                                _vm._s(
                                                  _vm.docNameHandle(ele.docName)
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "attachment_uploadFile_span"
                                              },
                                              [_vm._v(_vm._s(ele.uploadMsg))]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "xui-row",
                      { staticClass: "item-line" },
                      [
                        _c("xui-col", { attrs: { span: 3 } }, [
                          _c("span", { staticClass: "item-title" }, [
                            _vm._v(" 漏洞详情：")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "xui-col",
                          { attrs: { span: 21 } },
                          [
                            _c(
                              "xui-row",
                              { staticClass: "detail-html item-value-left" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "QRCode",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.data.content)
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                         " +
                                        _vm._s(_vm.data.content) +
                                        "\n                       "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "xui-row",
                      { staticClass: "item-line" },
                      [
                        _c("xui-col", { attrs: { span: 3 } }, [
                          _c("span", { staticClass: "item-title" }, [
                            _vm._v("处理记录：")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "xui-col",
                          { attrs: { span: 21 } },
                          _vm._l(_vm.data.approveRecordList, function(item) {
                            return _c(
                              "div",
                              {
                                key: item.approveTime,
                                staticClass: "vulLogs-line"
                              },
                              [
                                _vm.data.closeReasonName &&
                                item.flowStatus === 10
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                         " +
                                          _vm._s(
                                            item.approveTime +
                                              "[" +
                                              item.flowStatusName +
                                              "] : 感谢您的提交，当前漏洞为" +
                                              _vm.data.closeReasonName +
                                              "，" +
                                              item.flowStatusName
                                          ) +
                                          "\n                       "
                                      )
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          item.approveTime +
                                            "[" +
                                            item.flowStatusName +
                                            "] : 感谢您的提交，漏洞" +
                                            item.flowStatusName
                                        )
                                      )
                                    ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "xui-divider xui-divider--horizontal"
                                })
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "xui-row",
                      { staticClass: "item-line" },
                      [
                        _c("xui-col", { attrs: { span: 3 } }, [
                          _c("span", { staticClass: "item-title" }, [
                            _vm._v(" 留言记录：")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("xui-col", { attrs: { span: 21 } }, [
                          _c(
                            "div",
                            { staticClass: "vulLogs-line" },
                            [
                              _vm._l(_vm.data.vulBbsReturnVOList, function(
                                item
                              ) {
                                return _c(
                                  "xui-row",
                                  { key: item.status, staticClass: "row" },
                                  [
                                    _c("xui-col", { attrs: { span: 4 } }, [
                                      item.isAdmin === 0 && _vm.$baseU
                                        ? _c("img", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src:
                                                "https://" +
                                                _vm.$baseU +
                                                ".honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/res/image?attachmentId=" +
                                                _vm.pictureUrl
                                            }
                                          })
                                        : _vm.$baseU
                                        ? _c("img", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src:
                                                "https://" +
                                                _vm.$baseU +
                                                ".honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/res/image?attachmentId=" +
                                                _vm.$defaultAvatar
                                            }
                                          })
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "xui-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "xui-row",
                                          { staticClass: "commLogs-user" },
                                          [_vm._v(_vm._s(item.bbsUser))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "xui-row",
                                          {
                                            staticClass: "commLogs-content",
                                            staticStyle: {
                                              "word-wrap": "break-word",
                                              "word-break": "break-all",
                                              "line-break": "anywhere"
                                            }
                                          },
                                          [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(item.content)
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "xui-row",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "10px"
                                            }
                                          },
                                          _vm._l(
                                            item.s3AttachmentVOList,
                                            function(ele, i) {
                                              return _c(
                                                "span",
                                                {
                                                  key: i,
                                                  staticClass:
                                                    "s3Attachment_uploadFile"
                                                },
                                                [
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass: "fa fa-file"
                                                    })
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "xui-link",
                                                    {
                                                      key: _vm.index,
                                                      staticClass:
                                                        "attachment_uploadFile_xui-link",
                                                      attrs: {
                                                        href: _vm.jumpUrl(ele),
                                                        disabled: ele.disabled,
                                                        type: "primary",
                                                        target: "_blank",
                                                        title: ele.docName
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                 " +
                                                          _vm._s(
                                                            _vm.docNameHandle(
                                                              ele.docName
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "attachment_uploadFile_span"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              ele.uploadMsg
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "xui-col",
                                      {
                                        staticClass: "commLogs-time",
                                        attrs: { span: 8 }
                                      },
                                      [
                                        _c("xui-row", [
                                          _vm._v(_vm._s(item.creationDate))
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "xui-divider xui-divider--horizontal"
                              })
                            ],
                            2
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isShowByStatus
                      ? _c(
                          "xui-form",
                          {
                            ref: "ruleForm",
                            attrs: { model: _vm.ruleForm, rules: _vm.rules }
                          },
                          [
                            _c(
                              "xui-row",
                              { staticClass: "item-line" },
                              [
                                _c("xui-col", { attrs: { span: 3 } }, [
                                  _c("span", { staticClass: "item-title" }, [
                                    _vm._v(" 发表留言：")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "xui-col",
                                  { attrs: { span: 21 } },
                                  [
                                    _c(
                                      "xui-form-item",
                                      {
                                        staticClass: "item-value-left",
                                        attrs: { prop: "message" }
                                      },
                                      [
                                        _c("xui-input", {
                                          staticStyle: { height: "180px" },
                                          attrs: {
                                            type: "textarea",
                                            maxlength: 2000,
                                            "aria-placeholder":
                                              "有异议的时候，在这里写内容，然后提交"
                                          },
                                          model: {
                                            value: _vm.ruleForm.message,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "message",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "ruleForm.message"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.isShowByStatus
                              ? _c(
                                  "xui-row",
                                  { staticClass: "item-line" },
                                  [
                                    _c("xui-col", { attrs: { span: 3 } }, [
                                      _c(
                                        "span",
                                        { staticClass: "item-title" },
                                        [_vm._v(" 上传附件：")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "xui-col",
                                      { attrs: { span: 21 } },
                                      [
                                        _c(
                                          "xui-form-item",
                                          {
                                            staticClass: "item-value-left",
                                            model: {
                                              value: _vm.ruleForm.fileList,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.ruleForm,
                                                  "fileList",
                                                  $$v
                                                )
                                              },
                                              expression: "ruleForm.fileList"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "upload-attachment"
                                              },
                                              [
                                                _c(
                                                  "xui-upload",
                                                  {
                                                    staticClass: "upload-demo",
                                                    attrs: {
                                                      action: _vm.action,
                                                      headers: _vm.xCsrfToken,
                                                      accept: ".zip,.7z,.rar",
                                                      "before-upload":
                                                        _vm.beforUploadZip,
                                                      "on-remove":
                                                        _vm.resetFile,
                                                      "on-exceed":
                                                        _vm.handleExceed,
                                                      "on-error":
                                                        _vm.reportError,
                                                      limit: 1,
                                                      "on-success":
                                                        _vm.handlePreviewZip,
                                                      "file-list":
                                                        _vm.ruleForm.fileList,
                                                      "with-credentials": true
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "xui-button",
                                                      {
                                                        attrs: {
                                                          size: "medium"
                                                        }
                                                      },
                                                      [_vm._v("选择文件")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "xui-upload__tip",
                                                        attrs: { slot: "tip" },
                                                        slot: "tip"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                               格式限制:7z,rar,zip格式,不超过200M。 "
                                                        ),
                                                        _vm.uploadMsg
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "upload-msg"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.uploadMsg
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowByStatus
                              ? _c(
                                  "xui-row",
                                  {
                                    staticClass:
                                      "is-justify-center xui-row--flex"
                                  },
                                  [
                                    _c(
                                      "xui-button",
                                      {
                                        staticClass:
                                          "xui-button--primary is-round",
                                        attrs: {
                                          id: "submitButton",
                                          disabled: _vm.submitDisabled
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.submitInfo("ruleForm")
                                          }
                                        }
                                      },
                                      [_c("span", [_vm._v("提交")])]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          staticClass: "warnning-wrap",
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.dialogVisible,
            width: _vm.$store.state.isMobile ? "80%" : "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "h3",
            {
              style: {
                "font-size": _vm.$store.state.isMobile ? "24px" : "16.5px"
              }
            },
            [_vm._v("荣耀安全应急响应中心服务条款")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrap",
              style: {
                "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:"
                )
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [_vm._v("真实姓名，身份证正反面照片及身份证号；")]),
                _vm._v(" "),
                _c("li", [_vm._v("银行卡号，开户行信息，银行名称；")]),
                _vm._v(" "),
                _c("li", [_vm._v("手机号码，邮寄地址；")]),
                _vm._v(" "),
                _c("li", [_vm._v("昵称，头像，邮箱，主页；")]),
                _vm._v(" "),
                _c("li", [_vm._v("QQ，微信，签名，团队；")]),
                _vm._v(" "),
                _c("li", [_vm._v("IP地址；")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "上述数据将会传输并保存至位于中华人民共和国境内的服务器。"
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v("点击“同意”，即表示您同意\n         "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-user-protocol",
                    attrs: { href: _vm.safetyURL, target: "_blank" }
                  },
                  [_vm._v("荣耀安全应急响应中心用户协议")]
                ),
                _vm._v("\n         ，并知悉\n         "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-secret-statement",
                    attrs: { href: _vm.privacyURL, target: "_blank" }
                  },
                  [_vm._v("关于安全应急响应中心与隐私的声明")]
                ),
                _vm._v("。")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer", center: "" }, slot: "footer" },
            [
              _c(
                "xui-button",
                { attrs: { size: "bigger" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "xui-button",
                {
                  attrs: { type: "primary", size: "bigger" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("同意")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isNotLogin && _vm.isEffect
        ? _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "失效提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("您的账号已经失效，请联系管理员")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.handleClose }
                    },
                    [_vm._v("返回首页")]
                  )
                ],
                1
              )
            ]
          )
        : _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "登录提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("系统检测到您未登录或登录失效，请先登录")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.login }
                    },
                    [_vm._v("荣耀账号登录")]
                  )
                ],
                1
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ec1adab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ec1adab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/report/UsercenterReportDetail.vue
// module id = null
// module chunks = 